import { Actions } from "../redux/constants/actionTypes";
import { getStore } from "./storeUtils";

export function clearData() {
  getStore().dispatch({
    type: Actions.SET_GET_SEPCIFIC_PLAN,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_SELECTED_ORG,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_SELECTED_SITE_DETAILS,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_SITE_OVERVIEW,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_ALL_SITES,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_FETCH_CHILD_ORGS,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_GET_ALL_BLUEPRINT,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_ALL_PLANS,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_ALL_LICENSE,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_UPCOMING_INVOICE,
    data: null,
  });
  getStore().dispatch({
    type: Actions.SET_INVOICE_HISTORY,
    data: null,
  });
  getStore().dispatch({
    type: Actions.API_FETCH_CHILD_ORGS,
    data: null,
  });
}
